module.exports = __webpack_public_path__ + "img/achievement_8.3067186e.png";